import React from "react";
import { Button as StyledButton } from "../styles";
import Icon from "./Icon";

const Button = ({ children, onClick, variant = "pri", disabled, title, icon }) => {
  return (
    <StyledButton
      title={title}
      onClick={disabled ? undefined : onClick}
      variant={variant}
      disabled={disabled}
    >
      {icon && <Icon name={icon} />}
      {children}
    </StyledButton>
  );
};

export default Button;
